import * as React from "react";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { Grid, MenuItem, Box, Paper, Button, Stack, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { addNewUser, getUserAddedStatus, userAdded } from "../../store/users";
import Form from "../common/Form";
import useForm from "../common/useForm";
import { useState } from "react";
import Controls from "../controls/Controls";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close"
import { useEffect } from "react";
import { BorderColor } from "@mui/icons-material";

const roles = [
  {
    title: "Admin",
    id: 1,
  },
  {
    title: "Tester",
    id: 2,
  },
  {
    title: "Developer",
    id: 3,
  },
  {
    title: "Architecture",
    id: 4,
  },
];

// const initialFormValues = {
//   //issueStatus: "",
//   id: 0,
//   firstName: "",
//   lastName: "",
//   email: "",
//   mobile: "",
//   addedBy: 1,
// };


export default function AddNewUser(props) {

  const { handleAddUser, setNotify, selectedUser } = props;
  const [initialFormValues, setInitialFormValues] = useState({
    //issueStatus: "",
    id: 0,
    role: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    addedBy: 1,
  })
  const [role, setRole] = useState(0);
  const [validateOnChange, setValidateOnChange] = useState(true);

  const validate = (fieldValues = formValues) => {
    let temp = { ...errors };
    // if ("issueStatus" in fieldValues)
    //   temp.issueStatus = fieldValues.issueStatus
    //     ? ""
    //     : "This field is required.";
    if ("reviewNotes" in fieldValues)
      temp.reviewNotes = fieldValues.reviewNotes
        ? ""
        : "This field is required.";

    setErrors({ ...temp });
    if (fieldValues === formValues)
      return Object.values(temp).every((x) => x === "");
  };

  const userAddedStatusSelector = useSelector(getUserAddedStatus)

  const { formValues, errors, setErrors, handleOnChange, resetForm } = useForm(
    initialFormValues,
    validateOnChange,
    validate,
    setValidateOnChange
  );

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (validate()) {
    dispatch(addNewUser(formValues));
    // }
  };

  useEffect(() => {
    if (userAddedStatusSelector) {
      setNotify({
        isOpen: true,
        message: `${formValues?.id === 0 ? "Added Successfully" : "Updated Successfully"}`,
        type: "success",
      });
      handleAddUser("save");
      resetForm();
    }
  }, [userAddedStatusSelector]);

  useEffect(() => {
    if (selectedUser) {
      setInitialFormValues({
        id: selectedUser?.id,
        firstName: selectedUser?.firstName,
        lastName: selectedUser?.lastName,
        email: selectedUser?.email,
        mobile: selectedUser?.mobile,
        addedBy: selectedUser?.addedBy,
      })

    }
  }, [selectedUser]);



  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
            <Controls.Select
              name="role"
              label="Select Role"
              option={roles}
            />
          </Grid> */}
          <Grid item xs={12}>
            <Controls.Input
              rows={3}
              name="role"
              label="Role"
              onChange={handleOnChange}
              value={formValues?.role}
            />
          </Grid>
          <Grid item xs={6}>
            <Controls.Input
              rows={3}
              name="firstName"
              label="First Name"
              onChange={handleOnChange}
              value={formValues?.firstName}
            />
          </Grid>
          <Grid item xs={6}>
            <Controls.Input
              rows={3}
              name="lastName"
              label="Last Name"
              onChange={handleOnChange}
              value={formValues?.lastName}
            />
          </Grid>
          <Grid item xs={6}>
            <Controls.Input
              rows={3}
              name="email"
              label="Email"
              onChange={handleOnChange}
              value={formValues?.email}
            />
          </Grid>
          <Grid item xs={6}>
            <Controls.Input
              rows={3}
              name="mobile"
              label="Mobile"
              onChange={handleOnChange}
              value={formValues?.mobile}
            />
          </Grid>
          <Grid item xs={6}>
            <Controls.Input
              rows={3}
              name="state"
              label="State"
              onChange={handleOnChange}
              value={formValues?.state}
            />
          </Grid>
          <Grid item xs={6}>
            <Controls.Input
              rows={3}
              name="city"
              label="City"
              onChange={handleOnChange}
              value={formValues?.city}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider sx={{ ml: -3, mr: -3, mb: 2 }} />
            <Stack spacing={2} direction="row" justifyContent="end">
              <Controls.Button
                text="Close"
                color="error"
                variant="outlined"
                size="small"
                onClick={() => handleAddUser(null)}
                startIcon={<CloseIcon />}
                sx={{
                  width:"80px",
                  '&:hover': {
                    backgroundColor: 'red',
                    color: 'white',
                    border: 'none',
                  }
                }}
              />

              <Controls.Button
                text="Save"
                size="small"
                type="submit"
                variant="outlined"
                startIcon={<SaveIcon />}
                sx={{
                  width:"80px",
                  color: 'black',
                  border: "1px solid black",
                  '&:hover': {
                    backgroundColor: 'black',
                    color: 'white',

                  }
                }}
              ></Controls.Button>
            </Stack>
          </Grid>
        </Grid>
      </Form>
    </>
  );
}
